import {
    API_BASE_URL,
    API_PROD_BASE_URL,
    WEB_DEV_BASE_URL,
    WEB_PROD_BASE_URL,
    CAMPAGNE_PROD_BASE_URL
} from "constants/ApiConstant";

const dev = {
    API_ENDPOINT_URL: API_BASE_URL + '/api',
    ASSET_ENDPOINT_URL: API_BASE_URL + '/data',
    ENV: "DEV"
};

const prod = {
    API_ENDPOINT_URL: API_PROD_BASE_URL + '/api',
    ASSET_ENDPOINT_URL: API_PROD_BASE_URL + '/data',
    ENV: "PROD"
};

const test = {
    API_ENDPOINT_URL: API_BASE_URL + '/api',
    ASSET_ENDPOINT_URL: API_BASE_URL + '/data',
    ENV: "TEST"
};

const getEnv = () => {

    console.log("process.env.NODE_ENV",process.env.NODE_ENV)

    switch (process.env.NODE_ENV) {
        case 'development':
            return dev
        case 'production':
            return prod
        case 'test':
            return test
        default:
            break;
    }
}

export const env = getEnv()
